/**
 * @author PoornaChandu
 * @description 
 */
import React ,{useState,useEffect } from 'react';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import axios from 'axios';
import { connect } from 'react-redux';
import localStorage from '../../../utils/localStorage';
import ReactEcharts from '../../Dashboard/Utils/Echarts/Echarts';
import { getGraphData } from '../apiCalls';
import { Radio, Select, DatePicker } from 'antd';
import { constants } from '../Utils/constants';
import TableComponent from '../Widget/Table';
import { API_FILE, IPAddress, REPORTS } from '../../../commons/api';
const { RangePicker } = DatePicker;
const { Option } = Select;
const color = [
  'orange',
  'tomato',
  'steelblue',
  'green',
  'pink',
  'voilet',
  'yellow',
  'red',
  'blue',
  'gray'
];
const GraphView = (props) => {
  // const [selectedInterval, setSelectedInterval] = useState(
  //   props.payload && props.payload.Interval ? props.payload.Interval : ''
  // );
  const operatorList =props.OperatorList ? props.OperatorList : [];
  const frequencyList = constants && constants.frequencyList ? constants.frequencyList : [];
  const [selectedOperator, setSelectedOperator] = useState(
    props.payload && props.payload.Operator ? props.payload.Operator : ''
  );
  const [payload, setPayload] = useState(props.payload || {});
  const index = props.index || '';
  const [userProfile,setUserProfile] =  useState(props.userProfile);
  const [translationCache, setTranslationCache] = useState(props.translationCache || []);
  // const [reportData, setReportData] = useState('');
  let fromDate =  dayjs(payload.FromDate).utc().local() ;
  let toDate =  dayjs(payload.ToDate).utc().local() ;
  const [json, setJson] = useState([]);
  const [graphType, setGraphType] = useState('line');
  // const [interval, setInterval] = useState('');
  const [option, setOption] = useState({});
  const [reportName, setReportName] = useState("");
  const [codeType,setCodeType] = useState(props.CodeType || 'Device');
  dayjs.extend(utc);
  // useEffect(() => {
  //   prepareData(json, payload);
  //   generateData(props.payload);
  //  }, [props.payload]);
  // useEffect(() => {
  //   if(props.payload !== payload){
  //     generateData(props.payload);
  //   }
  // }, [props.payload]);
  // useEffect(() => {
  //   if (codeType !== props.CodeType) {
  //     setCodeType(props.CodeType);
  //   }
  //   if (props.translationCache !== translationCache || props.userProfile !== props.userProfile) {
  //     setTranslationCache(props.translationCache);
  //   }
  // }, [props.translationCache, props.userProfile,props.CodeType]);
  useEffect(() => {
    generateData(payload);
    setReportName(reportName);
  }, [payload,reportName]);
  useEffect(() => {
    setTranslationCache(translationCache);
    setUserProfile(userProfile);
    if (codeType !== props.CodeType) {
      setCodeType(props.CodeType);
    }
  }, [props.translationCache, props.userProfile,props.CodeType]);
  const getReportNametoDownload = async (excelData, Type, viewType, SelectedDate, trendIndex, param) => {
    let { translationCache } = props;
    let Consumption = translation('Trend');
    if (viewType === 'Single' && Type === 'historic') {
      Consumption = param ? translation(param) : translation('Trend');
    }
    let payload = {
      PortName: 'Rubus',
      Name: Type && Type ? translation(Type) : translation('Trend'),
      Consumption,
      Data: excelData || [],
      ReportType: 'singleHierarchy',
      GeneratedDate: dayjs().format('YYYY-MM-DD HH:mm:ss'),
      SelectedDate:
        dayjs.utc(SelectedDate.From).format('YYYY-MM-DD HH:mm:ss') +
        '~' +
        dayjs.utc(SelectedDate.To).format('YYYY-MM-DD HH:mm:ss'),
      SelectionType: 'dateRange',
      IsTranslate: translationCache && translationCache['GeneratedDate'] ? true : false,
      translationList: {
        GeneratedDate: translation('GeneratedDate'),
        SelectedDate: translation('SelectedDate')
      }
    };
    let siteId = localStorage.get('currentSite');
    let accessToken = localStorage.get('accessToken');
    let options = {
      method: 'POST',
      url: `${API_FILE.GenerateExcel}?SiteId=${siteId}`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      },
      data: JSON.stringify(payload)
    };
    return axios(options)
      .then(({ data }) => {
        return data;
      })
      .catch(() => {
        return '';
      });
  };
  const downLoadExcel = (file) => {
    const link = document.createElement('a');
    link.href = `${IPAddress.LOCAL}${REPORTS.Reports}/${file}`; 
    link.setAttribute('download', file); 
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
  const prepareData = async (json, trendData) => {
    let xaxis = [];
    let series = [];
    let option = getOption();
    setGraphType(graphType);
    let legendsdata = [];
    if (json && Array.isArray(json)) {
      json && Array.isArray(json) && json.map((Data) => {

            let data = {
                ...Data,
                DateTime: dayjs.utc(Data.DateTime, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm')
            };
            legendsdata.push({
                name: data.Description,
                icon: 'roundRect',
                textStyle: {
                    fontSize: 16
                }
            });
            if (!xaxis.includes(data.DateTime)) {
                xaxis.push(data.DateTime);
            }
            let existingSeriesIndex = series.findIndex(e => e.name === data.Name);
            if (existingSeriesIndex !== -1) {
                if (codeType === 'Device') {
                    series[existingSeriesIndex].data.push([
                        data.DateTime,
                        data.Value,
                        data.ParameterCode,
                        data.DeviceCode
                    ]);
                } else {
                    series[existingSeriesIndex].data.push([
                        data.DateTime,
                        data.Value,
                        data.ParameterCode,
                        data.AssetCode
                    ]);
                }
            } else {
                let obj = {
                    dataobj: data,
                    name: data.Name,
                    data: [[data.DateTime, data.Value, data.ParameterCode, codeType === 'Device' ? data.DeviceCode : data.AssetCode]],
                    type: graphType && graphType !== 'Area' ? graphType : 'line',
                    ...(graphType && graphType === 'Area' ? { areaStyle: {} } : {})
                };
                series.push(obj);
            }
            return null;
        });
    }
    xaxis.sort((a, b) => dayjs(a).diff(dayjs(b)));
    let seriesDataObject =  series &&
    Array.isArray(series) && series.map((seriesData) => {
        let DataVal = { ...seriesData };
        delete DataVal.dataobj;
        return {
            ...DataVal,
            name: `${translation(seriesData.dataobj.ParameterName)} (${translation(codeType === 'Device' ? seriesData.dataobj.DeviceName : seriesData.dataobj.AssetName)})`
        };
    });
      option.xAxis.data = xaxis;
      option.series = seriesDataObject;
      option.legend = [...legendsdata];
      setOption(option);
    let reportData = json &&Array.isArray(json) && json.map((data) => {
        return {
            [translation('DateTime')]: dayjs.utc(data.DateTime, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss'),
            [translation('Name')]: `${translation(data.ParameterName)} (${translation(codeType === 'Device' ? data.DeviceName : data.AssetName)})`,
            [translation('Value')]: translation(data.Value),
            [translation('Description')]: `${translation(data.ParameterName)} (${translation(codeType === 'Device' ? data.DeviceName : data.AssetName)})`,
            [translation(codeType === 'Device' ? 'DeviceName' : 'AssetName')]: translation(codeType === 'Device' ? data.DeviceName : data.AssetName),
            [translation('ParameterName')]: translation(data.ParameterName),
            val: translation(data.ParameterName)
        };
    });
    let ReportName ={};
    if (trendData) {
        let { FromDate, ToDate } = trendData;
        let value = reportData && reportData[0] && reportData[0].val || '';
        ReportName = await getReportNametoDownload(reportData, trendData.Type, trendData.ViewType, { From: FromDate, To: ToDate }, index, value);
      //  setReportName(ReportDataFile && ReportDataFile.file ? ReportDataFile.file :'');
    setReportName(ReportName.file || '');
    }
};
  const getOption = () => {
    let options ={
      legend: {
        icon: 'roundRect'
      },
      tooltip: {
        trigger: 'axis'
      },
      toolbox: {
        showTitle: false,
        orient: 'horizontal',
        itemSize: 15,
        feature: {
          myTool1: {
            show: true,
            title: 'custom extension method 1',
            icon: 'path://M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494zM514.1 580.1l-61.8-102.4c-2.2-3.6-6.1-5.8-10.3-5.8h-38.4c-2.3 0-4.5.6-6.4 1.9-5.6 3.5-7.3 10.9-3.7 16.6l82.3 130.4-83.4 132.8a12.04 12.04 0 0 0 10.2 18.4h34.5c4.2 0 8-2.2 10.2-5.7L510 664.8l62.3 101.4c2.2 3.6 6.1 5.7 10.2 5.7H620c2.3 0 4.5-.7 6.5-1.9 5.6-3.6 7.2-11 3.6-16.6l-84-130.4 85.3-132.5a12.04 12.04 0 0 0-10.1-18.5h-35.7c-4.2 0-8.1 2.2-10.3 5.8l-61.2 102.3z',
            onclick: () => {
              if (reportName) {
                downLoadExcel(reportName); 
              } else {
                console.error('reportName is not defined 2222');
              }
            }
          },
          saveAsImage: {}
        }
      },
      xAxis: {
        type: 'category',
        data: []
      },
      yAxis: {
        type: 'value'
      },
      series: [
        {
          data: [],
          type: 'line'
        }
      ]
    };
    return options;
    };
  const generateData = async (payload) => {
    const  Json =  await getGraphData(payload);
    // setPayload(payload);
    let GraphType = payload.GraphType || 'line';
    setGraphType(GraphType);
    setReportName(reportName);
     await prepareData(Json, payload);
    const newOption = {
      tooltip: {
        trigger: 'axis'
      },
      legend: {
        name: [Json[0]?.Name || ''],
        icon: 'roundRect',
        textStyle: {
          fontSize: 15
        }
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      toolbox: {
        showTitle: false,
        orient: 'horizontal',
        itemSize: 15,
        feature: {
          myTool1: {
            show: true,
            title: 'custom extension method 1',
            icon: 'path://M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494zM514.1 580.1l-61.8-102.4c-2.2-3.6-6.1-5.8-10.3-5.8h-38.4c-2.3 0-4.5.6-6.4 1.9-5.6 3.5-7.3 10.9-3.7 16.6l82.3 130.4-83.4 132.8a12.04 12.04 0 0 0 10.2 18.4h34.5c4.2 0 8-2.2 10.2-5.7L510 664.8l62.3 101.4c2.2 3.6 6.1 5.7 10.2 5.7H620c2.3 0 4.5-.7 6.5-1.9 5.6-3.6 7.2-11 3.6-16.6l-84-130.4 85.3-132.5a12.04 12.04 0 0 0-10.1-18.5h-35.7c-4.2 0-8.1 2.2-10.3 5.8l-61.2 102.3z',
            onclick: () => {
              if (reportName) {
                downLoadExcel(reportName); 
              } else {
                console.error('reportName is not defined data1');
              }
            }
          },
          saveAsImage: {}
        }
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: Json && Array.isArray(Json) && Json.map(data => data.DateTime)
      },
      yAxis: {
        type: 'value'
      },
      series: [
        {
          name: Json[0]?.Name || '',
          type: GraphType,
          data: Json && Array.isArray(Json) && Json.map(data => data.Value)
        }
      ]
    };
    setOption(newOption);
  };
  const translation = (keyword) => {
    const { translationCache } = props;
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };
  const disabledDate = (current) => {
    return current > dayjs().startOf('day').add(1, 'day');
  };
  const onIntervalChange = async (Interval) => {
    let updatedPayload = { ...payload, Interval };
    if (updatedPayload.GraphType !== 'Table') {
      await generateData(updatedPayload);
      setPayload(updatedPayload);
      // setSelectedInterval(Interval);
    } else {
      const jsonData = await getGraphData(updatedPayload);
      setJson(jsonData);
      // setSelectedInterval(Interval);
      setPayload(updatedPayload);
    }
  };
  const onCheckboxChange = async (Operator) => {
    let updatedPayload = { ...payload, Operator };
    if (updatedPayload.GraphType !== 'Table') {
      await generateData(updatedPayload);
      setPayload(updatedPayload);
      setSelectedOperator(Operator);
    } else {
      const jsonData = await getGraphData(updatedPayload);
      setPayload(updatedPayload);
      setJson(jsonData);
      setSelectedOperator(Operator);
    }
  };
  const radioOnChange = async (e) => {
    const GraphType = e.target.value;
    let updatedPayload = { ...payload, GraphType };
    if (GraphType !== 'Table') {
      await generateData(updatedPayload);
      setPayload(updatedPayload);
      setGraphType(GraphType);
    } else {
      const jsonData = await getGraphData(updatedPayload);
      setJson(jsonData);
      setGraphType(GraphType);
      setPayload(updatedPayload);
    }
  };
  const onChangeFromDate_ToDate1 = (selectedFromDate_ToDate1) => {
    let updatedPayload = {
      ...payload,
      FromDate: dayjs(selectedFromDate_ToDate1[0]).utc().format('YYYY-MM-DD HH:mm:ss'),
      ToDate: dayjs(selectedFromDate_ToDate1[1]).utc().format('YYYY-MM-DD HH:mm:ss')
    };
    // setSelectedFromDate_ToDate1(selectedFromDate_ToDate1);
    generateData(updatedPayload);
    setPayload(updatedPayload);
  };
    return (
      <>
        <div style={{ display: 'flex' }}>
         {/* <Form.Item
            name={'selectedFromDate_ToDate1'}
            label={this.translation(constant.Select_Range)}
            rules={[
              {
                required: false,
                message: this.translation('Please Select DateRanges!')
              }
            ]}
          > */}          
          <RangePicker
            showTime={{ format: 'HH:mm' }}
            format="YYYY-MM-DD HH:mm"
            style={{ width: '330px' }}
            placeholder={[translation('Start DateTime'), translation('End DateTime')]}
            value={[fromDate,toDate]}
            onChange={onChangeFromDate_ToDate1}
            disabledDate={disabledDate}
          />
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', margin: '5px 0px' }}>
          <Radio.Group onChange={radioOnChange} value={graphType}>
            <Radio.Button value={'line'}>Line</Radio.Button>
            <Radio.Button value={'bar'}>Bar</Radio.Button>
            <Radio.Button value={'Area'}>Area</Radio.Button>
            <Radio.Button value={'Table'}>Table</Radio.Button>
          </Radio.Group>
          {payload && payload.Type === 'historic' ? (
            <>
              <Select
                showSearch
                style={{ width: 100 }}
                value={payload.Interval}
                placeholder="Select Interval"
                onChange={onIntervalChange}
                options={frequencyList}
              />
              <Select
                showSearch
                style={{ width: 100 }}
                value={selectedOperator}
                placeholder="Select Operator"
                onChange={onCheckboxChange}
              >
                {operatorList &&
                  Array.isArray(operatorList) &&operatorList.map((operator, index) => (
                  <Option key={index} value={operator.Key}>
                    {operator.Value}
                  </Option>
                ))}
              </Select>
            </>
          ) : null}
          </div>
          {graphType === 'Table' ? (
          <TableComponent
            panelData={{
              graph: 'trends',
              trendData: json,
              colors: color,
              GraphType: graphType
            }}
            currentTimeZone={props.currentTimeZone}
            className="trendTable"
            dataSource={json}
          />
          ) : (
          <ReactEcharts
            option={option}
            notMerge={true}
            lazyUpdate={true}
            style={{ height: '90%', width: '100%' }}
            className="react_for_echarts"
            theme="light"
          />
          )}
      </>
    );
};
const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache,
  currentTimeZone: state.LayoutReducer.currentTimeZone
});
export default connect(mapStateToProps)(GraphView);